module.exports = __webpack_public_path__ + "static/img/btn_flag_gb.e4e61fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cloud/btn_flag_gb.png
// module id = 548
// module chunks = 3